import i18n from '@/locales'

export default {
  created () {
    this.columns = [
      {
        field: 'title',
        title: i18n.t('scope.text_747'),
        minWidth: 100,
      },
      {
        field: 'invoice_type',
        title: i18n.t('scope.text_746'),
        minWidth: 80,
        formatter: ({ cellValue }) => {
          const obj = {
            ordinary: i18n.t('scope.text_721'),
            special: i18n.t('scope.text_722'),
            ngo: i18n.t('scope.text_723'),
          }
          return obj[cellValue]
        },
      },
      {
        field: 'project_domain',
        title: i18n.t('scope.text_421'),
        minWidth: 100,
      },
      {
        field: 'register_no',
        title: i18n.t('scope.text_748'),
        minWidth: 100,
      },
      {
        field: 'bank_name',
        title: i18n.t('scope.text_749'),
        minWidth: 100,
      },
      {
        field: 'bank_account',
        title: i18n.t('scope.text_777'),
        minWidth: 120,
      },
      {
        field: 'phone',
        title: i18n.t('scope.text_773'),
        minWidth: 80,
      },
    ]
  },
}
